import React from 'react';
import { Link } from 'react-router-dom';
import { C } from '../tokens';
import Icon from '../components/Icon';

export default function EmailSuccessPage() {
  return (
    <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: 16, background: '#f9fafb', fontFamily: "'Public Sans','Inter',sans-serif" }}>
      {/* Brand logo above card */}
      <div style={{ display: 'flex', alignItems: 'center', gap: 10, justifyContent: 'center', marginBottom: 32 }}>
        <div style={{ width: 36, height: 36, background: C.primary, borderRadius: 10, display: 'grid', placeItems: 'center' }}>
          <svg width="20" height="20" viewBox="0 0 24 24" fill="#fff">
            <path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z" />
          </svg>
        </div>
        <h1 style={{ fontSize: 24, fontWeight: 700, letterSpacing: '-.02em' }}>
          Nieramind<span style={{ color: C.primary }}>.AI</span>
        </h1>
      </div>

      {/* Card */}
      <section
        style={{
          width: '100%',
          maxWidth: 450,
          background: '#fff',
          borderRadius: 16,
          border: '1px solid #f3f4f6',
          boxShadow: '0 1px 3px rgba(0,0,0,.04)',
          padding: '40px 32px',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          textAlign: 'center',
        }}
      >
        {/* Green checkmark circle */}
        <div
          style={{
            width: 64,
            height: 64,
            borderRadius: '50%',
            background: '#dcfce7',
            display: 'grid',
            placeItems: 'center',
            marginBottom: 24,
          }}
        >
          <Icon name="check" size={36} style={{ color: '#16a34a' }} />
        </div>

        {/* Headline */}
        <h1 style={{ fontSize: 24, fontWeight: 700, color: '#111827', marginBottom: 16 }}>
          Check your email
        </h1>

        {/* Description */}
        <p style={{ fontSize: 14, color: '#6b7280', lineHeight: 1.7, marginBottom: 24, maxWidth: 340 }}>
          We have sent a password reset link to your email address. Please follow the instructions in the email to securely reset your password.
        </p>

        {/* Spam hint */}
        <p style={{ fontSize: 12, color: '#9ca3af', marginBottom: 32 }}>
          If you don't see it in your inbox, please check your spam folder.
        </p>

        {/* Back to Login — outlined button */}
        <Link
          to="/login"
          style={{
            display: 'block',
            width: '100%',
            padding: '13px 16px',
            borderRadius: 8,
            border: `2px solid ${C.primary}`,
            background: '#fff',
            color: C.primary,
            fontSize: 15,
            fontWeight: 600,
            textDecoration: 'none',
            textAlign: 'center',
            transition: 'background .15s',
            marginBottom: 24,
          }}
          onMouseEnter={e => e.currentTarget.style.background = '#fef2f2'}
          onMouseLeave={e => e.currentTarget.style.background = '#fff'}
        >
          Back to Login
        </Link>

        {/* Resend link */}
        <p style={{ fontSize: 12, color: '#6b7280' }}>
          Didn't receive the email?{' '}
          <button
            style={{
              border: 'none',
              background: 'none',
              color: C.primary,
              fontWeight: 700,
              cursor: 'pointer',
              fontSize: 12,
              textDecoration: 'none',
            }}
          >
            Resend link
          </button>
        </p>
      </section>

      {/* Footer */}
      <footer style={{ marginTop: 32 }}>
        <p style={{ fontSize: 12, color: '#9ca3af' }}>© 2024 Nieramind.AI. All rights reserved.</p>
      </footer>
    </div>
  );
}
